import {
    BILLING_VENDORS_FETCHING,
    BILLING_VENDORS_FAILED,
    BILLING_VENDORS_SUCCESS
} from "../actions/types";
  
  const initialState = {
    result: null,
    isFetching: false,
    isError: false,
  };
  
  export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case BILLING_VENDORS_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case BILLING_VENDORS_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case BILLING_VENDORS_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
  }